/** Centralized token color registry for consistent visuals across all views. */

interface TokenColor {
  bg: string;
  text: string;
  border: string;
}

const TOKEN_COLORS: Record<string, TokenColor> = {
  ETH: { bg: "#627EEA", text: "#627EEA", border: "rgba(98,126,234,0.4)" },
  WETH: { bg: "#8B7EEA", text: "#8B7EEA", border: "rgba(139,126,234,0.4)" },
  USDC: { bg: "#2775CA", text: "#2775CA", border: "rgba(39,117,202,0.4)" },
  USDT: { bg: "#26A17B", text: "#26A17B", border: "rgba(38,161,123,0.4)" },
  DAI: { bg: "#F5AC37", text: "#F5AC37", border: "rgba(245,172,55,0.4)" },
  WBTC: { bg: "#F09242", text: "#F09242", border: "rgba(240,146,66,0.4)" },
};

const FALLBACK: TokenColor = {
  bg: "#6b7280",
  text: "#6b7280",
  border: "rgba(107,114,128,0.4)",
};

export function getTokenColor(symbol: string): TokenColor {
  return TOKEN_COLORS[symbol.toUpperCase()] ?? FALLBACK;
}

/** Flat background color for charts/bars — just the hex value. */
export function getTokenBg(symbol: string): string {
  return getTokenColor(symbol).bg;
}
